import Text from 'components/Text/Text';
import React from 'react';
import { RequestEntity, IItemGame } from 'types';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import classNames from 'classnames';
import style from './Info.module.scss';

interface IInfo {
	isOpenInfo: boolean;
	data: IItemGame;
}

const Info: React.FC<IInfo> = ({ isOpenInfo, data }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isOpenInfo });
	const descriptionClasses = classNames(style.blockValue, style.description);

	return (
		<div className={containerClasses} data-test="Info">
			<div className={style.wrapper}>
				<div className={style.infoContainer}>
					<div className={style.imgWrapper}>
						<ImgUploaderByEntityId
							resource={RequestEntity.Games}
							entityID={data.iconPath ? data.id : ''}
							photoSize="Small"
							isMakeImageRequest={isOpenInfo}
							loaderSize="small"
							noImageIdIcon="gameDefaultAvatar"
						/>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="nameLabel"
							theme="neutralLight"
						/>
						<Text
							className={style.blockValue}
							translationKey={data.name}
							withTooltip={true}
							data-test="gameName"
						/>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="applicationIdLabel"
							theme="neutralLight"
						/>
						<Text
							className={style.blockValue}
							translationKey={data.applicationId}
							withTooltip={true}
							data-test="applicationId"
						/>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="versionCodeLabel"
							theme="neutralLight"
						/>
						<Text
							className={style.blockValue}
							translationKey={String(data.versionCode)}
							withTooltip={true}
							data-test="versionCode"
						/>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="versionNameLabel"
							theme="neutralLight"
						/>
						<Text
							className={style.blockValue}
							translationKey={data.versionName}
							withTooltip={true}
							data-test="versionName"
						/>
					</div>
					<div className={style.block}>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="developerLabel"
							theme="neutralLight"
						/>
						<Text
							className={style.blockValue}
							translationKey={data.developerName}
							withTooltip={true}
							data-test="developerName"
						/>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="categoryLabel"
							theme="neutralLight"
						/>
						<Text
							className={style.blockValue}
							translationKey={data.gameCategoryName}
							withTooltip={true}
							data-test="gameCategoryName"
						/>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="descriptionLabel"
							theme="neutralLight"
						/>
						<Text
							className={descriptionClasses}
							translationKey={data.description}
							withTooltip={true}
							data-test="description"
						/>
						<Text
							className={style.blockName}
							translationNameSpace="listing"
							translationKey="gameFileLabel"
							theme="neutralLight"
						/>
						<Text
							className={style.blockValue}
							translationKey={data.gamePath}
							withTooltip={true}
							data-test="gamePath"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default React.memo(Info);
